import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSettings } from 'yordex-ui-kit'

const AdminHomeRedirect = () => {
  const { uiSettings } = useSettings()
  const isAccountsPageEnabled = uiSettings?.pages.find(
    (page) => page.id === 'ACCOUNTS_OVERVIEW',
  )?.visible

  if (isAccountsPageEnabled) {
    return <Navigate to="/accounts" />
  }
  return <Navigate to="/spend" />
}

export default AdminHomeRedirect
